export const chart = {
  mode: "zh",
  chart: {
    title:
      "网红营销，入驻店铺… 虽然尝试了很多进军中国的方法，还是没有找到我的客户",
    description: "SEL-DI 帮您找寻最适合 ‘产品’ 的销售与营销方法。",
  },
};
